import React from 'react';
import { getCostForAddon } from '../utils';

export default function ({ isInternal }) {
  const reviewLabel = isInternal ? 'Chroma Key' : 'Green Screen';
  const icon = 'chromakey';

  return ({
    addonsCosts,
    billingEntityCode,
    includedAddons




  }) => {
    const zeroCost = getCostForAddon({ billingEntityCode, costs: null });
    const cost = includedAddons.includes('CHROMA_KEY') ?
    zeroCost :
    getCostForAddon({ costs: addonsCosts.CHROMA_KEY.costs, billingEntityCode });

    return [
    { reviewLabel, label: 'No', value: false, suffix: <span>{zeroCost}</span>, icon, cost: zeroCost },
    { reviewLabel, label: 'Yes', value: true, suffix: <span>{cost}</span>, icon, cost }];

  };
}